import script from "./imageCutout.component.vue?vue&type=script&setup=true&lang=ts"
export * from "./imageCutout.component.vue?vue&type=script&setup=true&lang=ts"

import "./imageCutout.component.vue?vue&type=style&index=0&id=1f9af6c4&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f9af6c4"]])

export default __exports__